/* Scholar kiwi variant — graduation cap with tassel and diploma scroll. */

import type { KiwiPalette } from "../kiwiPalettes";

export function renderScholar(p: KiwiPalette) {
  return (
    <>
      {/* Graduation cap - crown */}
      <rect x="11" y="0" width="10" height="2" fill={p.accent} opacity={0.6} />
      {/* Graduation cap - brim */}
      <rect x="6" y="2" width="20" height="2" fill={p.accent} opacity={0.5} />
      {/* Tassel string */}
      <rect x="24" y="2" width="2" height="3" fill={p.accent} opacity={0.4} />
      {/* Tassel end */}
      <rect x="25" y="5" width="2" height="2" fill={p.accent} opacity={0.5} />

      {/* Body — top starts at y=4 to connect with cap */}
      <path d="M12 4H20V8H24V10H26V18H24V22H20V24H12V22H8V18H6V10H8V8H12V4Z" fill={p.body} />

      {/* Highlight */}
      <rect x="20" y="12" width="2" height="2" fill={p.highlight} opacity={0.3} />
      <rect x="22" y="10" width="2" height="2" fill={p.highlight} opacity={0.2} />

      {/* Beak */}
      <path d="M4 12H6V14H4V12ZM2 14H4V16H2V14ZM2 16H4V18H2V16ZM4 18H6V20H4V18Z" fill={p.beak} />

      {/* Eye */}
      <rect x="10" y="10" width="6" height="6" fill={p.eyeBg} />
      <rect x="12" y="12" width="2" height="2" fill={p.pupil} />

      {/* Diploma scroll held on right */}
      <rect x="24" y="16" width="6" height="2" fill={p.eyeBg} />
      <rect x="24" y="15" width="2" height="4" fill={p.accent} opacity={0.35} />
      <rect x="28" y="15" width="2" height="4" fill={p.accent} opacity={0.35} />

      {/* Feet */}
      <path d="M12 24H14V28H12V24ZM10 28H16V30H10V28Z" fill={p.body} />
      <path d="M18 24H20V28H18V24ZM16 28H22V30H16V28Z" fill={p.body} />
    </>
  );
}
